import GroupIcon from '@mui/icons-material/Group';
import HomeIcon from '@mui/icons-material/Home';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import ScaleIcon from '@mui/icons-material/Scale';
import LoginIcon from '@mui/icons-material/Login';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import InfoIcon from '@mui/icons-material/Info';
import FeedbackIcon from '@mui/icons-material/Feedback';
import CalculateIcon from '@mui/icons-material/Calculate';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';

// Baut die Navigationspunkte abhängig von Login-/Admin-Status.
export function buildNavItems(isLoggedIn, isAdmin) {
    return isLoggedIn
        ? [
            { label: 'Home', path: '/dashboard', premiumRequired: false, icon: <HomeIcon /> },
            { label: 'Training', path: '/addTraining', premiumRequired: false, icon: <FitnessCenterIcon /> },
            { label: 'Cardio', path: '/cardio', premiumRequired: true, icon: <DirectionsRunIcon /> },
            { label: 'Max Rep', path: '/maxRepCalc', premiumRequired: true, icon: <CalculateIcon /> },
            { label: 'Tracker', path: '/tracker', premiumRequired: true, icon: <ScaleIcon /> },
            { label: 'Gruppen', path: '/gruppen', premiumRequired: false, icon: <GroupIcon /> },
            { label: 'Feedback', path: '/feedback', premiumRequired: false, icon: <FeedbackIcon /> },
            { label: 'Impressum', path: '/impressum', premiumRequired: false, icon: <InfoIcon /> },
            ...(isAdmin ? [{ label: 'Admin', path: '/admin', premiumRequired: false, icon: <AdminPanelSettingsIcon /> }] : []),
        ]
        : [
            { label: 'Login', path: '/login', premiumRequired: false, icon: <LoginIcon /> },
            { label: 'Impressum', path: '/impressum', premiumRequired: false, icon: <InfoIcon /> },
            ...(isAdmin ? [{ label: 'Admin', path: '/admin', premiumRequired: false, icon: <AdminPanelSettingsIcon /> }] : []),
        ];
}
